import { render } from "./SingletonData.vue?vue&type=template&id=7d165d31"
import script from "./SingletonData.vue?vue&type=script&lang=js"
export * from "./SingletonData.vue?vue&type=script&lang=js"

import "./SingletonData.vue?vue&type=style&index=0&id=7d165d31&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__